import type { ContentRefKind } from '@gitbook/app-content-refs';
import type { Change } from '@gitbook/slate';

import { addMarkToSelection } from '../type-plugin';

export const MENTION_CONTEXT_TYPE = 'mentionContext';

/**
 * Content refreferences that are allowed to be inserted into an inline mention.
 */
export const ALLOWED_CONTENT_REFS_IN_INLINE_MENTION: ContentRefKind[] = [
    'anchor',
    'page',
    'space',
    'url',
    'file',
    'user',
];

/**
 * Trigger the mention input with a symbol being highlighted in the document.
 */
export function triggerEditorMentionPicker(change: Change, symbol: string): Change {
    return addMarkToSelection(change, {
        type: MENTION_CONTEXT_TYPE,
        data: { symbol, value: '' },
    });
}
